import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/navigation/Sidebar';
import { HandoffProvider } from '../context/handoffContext';

export const DashboardLayout = () => {
  return (
    <HandoffProvider>
      <div className="min-h-screen bg-gradient-to-br from-brand-blue/5 to-brand-secondary-blue/10 text-black">
        <div className="flex min-h-screen">
          <Sidebar />
          <main className="flex-1 min-w-0 p-6 relative">
            <div
              className="absolute inset-0 opacity-5 pointer-events-none"
              style={{
                backgroundImage: `radial-gradient(circle at 1px 1px, #082939 1px, transparent 0)`,
                backgroundSize: '20px 20px',
              }}
            ></div>
            <div className="relative z-10">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </HandoffProvider>
  );
};
